export const categories = [
  {
    slug: "deep-dive",
    name: "深扒解读",
    desc: "把零散的路透、声明与爆料拼成一条完整线索，还原事件真正的起点。",
    icon: "ri-search-eye-line",
  },
  {
    slug: "backstage",
    name: "幕后逻辑",
    desc: "从商业合约、团队博弈与宣发节奏切入，解释热搜背后谁在推动、为了什么。",
    icon: "ri-film-line",
  },
  {
    slug: "relations",
    name: "人物关系",
    desc: "梳理合作、同门与资源交集，理清一张关系网如何影响舆论走向。",
    icon: "ri-links-line",
  },
  {
    slug: "details",
    name: "细节复盘",
    desc: "盯着时间、措辞与镜头，用细节比对判断哪些信息经得起推敲。",
    icon: "ri-focus-3-line",
  },
  {
    slug: "opinion",
    name: "舆论观察",
    desc: "不做站队，只观察情绪如何聚集、词条如何变化、话题如何被引导。",
    icon: "ri-pulse-line",
  },
];

export const articles = [
  {
    slug: "variety-editing-dispute",
    title: "综艺剪辑争议复盘：一条被删掉的支线如何引爆舆论",
    summary:
      "正片里消失的三分钟，被观众从路透和花絮里一点点拼了回来。剪辑到底能改变多少叙事？我们按镜头逐帧比对了一遍。",
    category: "深扒解读",
    categorySlug: "deep-dive",
    tags: ["综艺", "剪辑", "舆论复盘"],
    author: "临街观察",
    date: "2026-09-08",
    readTime: 9,
    views: 18240,
    hot: 98,
    featured: true,
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20newsroom%20desk%20with%20film%20strips%2C%20vintage%20monitor%20and%20paper%20notes%2C%20terracotta%20and%20cream%20tone%2C%20soft%20daylight%2C%20minimal%20stylized%20still%20life%2C%20high%20detail%20magazine%20photography&width=1600&height=900&seq=hlch-variety-01&orientation=landscape",
    coverAlt: "暖色调剪辑台场景，象征综艺剪辑争议的编辑视角",
    lead:
      "一档综艺上线当晚，讨论区很快分裂成两派：一派认为某位嘉宾被「恶意剪辑」，另一派则觉得只是叙事取舍。争议的核心其实不在情绪，而在于——观众看到的版本，是否等于现场发生的版本。",
    points: [
      "被删掉的支线往往承载了动机解释，删减后人物行为会显得突兀。",
      "花絮与路透是对照正片最直接的两份旁证，但两者也各有立场。",
      "剪辑节奏服务于单期看点，与人物长期形象未必一致。",
    ],
    sections: [
      {
        heading: "先厘清：争议究竟发生在哪一层",
        paragraphs: [
          "观众的直觉判断往往来自「违和感」：某个反应太大、某句话接不上、某个转场突然。这种违和感是真实存在的信号，它不代表一定有恶意，但确实说明叙事链条出现了断点。",
          "我们把它拆成三层：素材层（现场发生了什么）、叙事层（节目组讲了哪个故事）、传播层（观众截取了哪一帧）。争议通常同时发生在前两层，却在第三层被放大。",
        ],
      },
      {
        heading: "镜头比对：消失的三分钟留下了什么",
        paragraphs: [
          "把正片、会员加更与场外花絮按时间码对齐后可以看到，被压缩的段落大多属于「解释性对话」——它们不制造笑点，却负责交代人物为什么这么做。",
          "删掉解释、保留结果，会让观众自行补全动机；而补全的方向取决于观众对这位嘉宾的既有印象。这就是为什么同一段剪辑，不同人会得出完全相反的结论。",
        ],
      },
      {
        heading: "舆论为什么在第二天才反转",
        paragraphs: [
          "首播当晚的讨论是情绪密度最高的，此时信息量最低；真正改变判断的是次日陆续放出的路透与现场观众笔记。信息补充的速度，直接决定了舆论的翻转速度。",
          "这也解释了一个常见现象：节目组的第一份回应往往赶在信息补齐之前发出，结果被后续材料反复打脸，反而坐实了「有问题」的印象。",
        ],
      },
      {
        heading: "给吃瓜的一点方法论",
        paragraphs: [
          "遇到类似争议，先看是否有可对齐的时间码，再看各方材料是否互相独立。独立信源越多，结论越稳；全部来自同一侧的材料，无论多少条，都只能算一条。",
          "最后提醒一句：剪辑可以决定先看到什么，但很难长期决定最终看到什么。耐心通常比站队更有用。",
        ],
      },
    ],
  },
  {
    slug: "co-branding-storm",
    title: "联名风波拆解：品牌与艺人之间的三重博弈",
    summary:
      "一次看上去是审美分歧的联名争议，实际牵动了品牌、艺人与平台三方。我们把三方的时间动作排在一起，看谁在真正让步。",
    category: "幕后逻辑",
    categorySlug: "backstage",
    tags: ["商业合作", "联名", "宣发"],
    author: "后台通道",
    date: "2026-09-05",
    readTime: 8,
    views: 14320,
    hot: 91,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20product%20collaboration%20concept%20with%20plain%20packaging%20boxes%20and%20warm%20mustard%20fabric%2C%20terracotta%20background%2C%20soft%20studio%20light%2C%20editorial%20minimal%20still%20life%2C%20no%20text&width=1200&height=750&seq=hlch-cobrand-02&orientation=landscape",
    coverAlt: "简约联名包装盒与织物静物，象征品牌联名合作",
    lead:
      "联名本该是双赢，但现实里它经常变成一场三方会谈：品牌要销量与声量，艺人要形象不被稀释，平台要话题热度。三方目标不一致时，最先被牺牲的往往是「故事」。",
    points: [
      "品牌的核心诉求是可量化的转化，艺人的核心诉求是形象的长期一致性。",
      "平台只关心讨论量，因此天然偏好冲突性表达。",
      "争议爆发后，谁先发声明，谁就承担了定义事件的责任。",
    ],
    sections: [
      {
        heading: "三方各要什么：一张利益对照表",
        paragraphs: [
          "品牌方要的是短期曝光与渠道动销，衡量标准清晰到可以按天看数据；艺人团队要的是这次合作是否与既有形象兼容，以及会不会带出旧话题。",
          "平台处在中间，它不承担形象风险，却能收获讨论红利，因此它的最优策略是把双方的分歧做成可传播的内容。理解这一点，就能理解为什么每次争议都「恰好」有那么多现场物料。",
        ],
      },
      {
        heading: "时间线里的让步信号",
        paragraphs: [
          "把三方的公开动作按小时排列会发现规律：品牌通常先撤物料、再补说明；艺人团队先沉默、后表态；平台则全程保持话题在线。",
          "真正能看出谈判结果的，不是措辞强硬的声明，而是物料的修改幅度。改图不改文案，通常意味着分歧停留在执行层；改文案又撤渠道，说明已经上升到合作条款。",
        ],
      },
      {
        heading: "为什么这类争议越来越短命",
        paragraphs: [
          "联名争议的生命周期正在变短，原因是同类合作太密集，公众的注意力被不断分流。一条热搜的保质期可能不到 48 小时。",
          "对品牌来说这是好消息，对艺人形象管理则未必——热度退得快，意味着澄清往往来不及被看见就已经翻篇。",
        ],
      },
    ],
  },
  {
    slug: "poster-billing-order",
    title: "海报番位之争：粉丝经济里那条看不见的排名线",
    summary:
      "同一张海报，换个站位就能吵上热搜。番位不只是一张图的排版问题，它背后是资源分配的公开表态。",
    category: "人物关系",
    categorySlug: "relations",
    tags: ["番位", "粉丝经济", "海报"],
    author: "番位观察员",
    date: "2026-09-02",
    readTime: 7,
    views: 12650,
    hot: 86,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20geometric%20layout%20of%20warm%20paper%20rectangles%20arranged%20in%20rows%2C%20terracotta%20and%20amber%20tones%2C%20soft%20shadow%20free%20flat%20composition%2C%20minimal%20graphic%20design%20concept&width=1200&height=750&seq=hlch-poster-03&orientation=landscape",
    coverAlt: "暖色纸片排列构成的海报排版抽象图",
    lead:
      "番位争议看起来鸡毛蒜皮，实质是一次公开的地位确认。位置怎么排、名字怎么列、谁的名字单独一行，这些细节会被粉丝当成资源分配的官方信号来解读。",
    points: [
      "番位是行业内部排序规则的外化，不是单纯的审美问题。",
      "粉丝敏感的不是位置本身，而是位置所暗示的资源倾斜。",
      "片方常用的模糊处理，短期降火，长期累积不满。",
    ],
    sections: [
      {
        heading: "番位规则从哪来",
        paragraphs: [
          "番位最初是合同条款，用于确定署名顺序与宣传权重，本身是商业约定。当它被搬到海报上，就变成了需要向公众解释的视觉语言。",
          "问题在于，合同语言是明确的，视觉语言是模糊的。同一张图，粉丝能读出三种不同的排序逻辑，争议由此产生。",
        ],
      },
      {
        heading: "排版里的三类信号",
        paragraphs: [
          "居左、居右与双列并列是三种常见处理。居左通常表示领衔，并列则表示平番，而错位排布往往是为了回避直接排序的折中方案。",
          "折中方案能压住一时的讨论，却会同时得罪两方——因为双方都读出了「不够明确」的意味。这也是很多番位争议反复出现的结构性原因。",
        ],
      },
      {
        heading: "观众该在意吗",
        paragraphs: [
          "对普通观众来说，番位与作品质量没有直接关系。真正值得关注的是角色戏份与叙事比重，那才是决定口碑的东西。",
          "但如果目标是理解舆论，番位就是一个极佳的切片：它把抽象的资源分配，转译成了一张谁都能看懂的图。",
        ],
      },
    ],
  },
  {
    slug: "casting-rumor-timeline",
    title: "选角传闻时间线还原：从路透到官宣的72小时",
    summary:
      "一条模糊的路透、两张打码的现场照、一次手滑点赞，三天里信息如何层层叠加，最后逼出一份措辞谨慎的官宣。",
    category: "细节复盘",
    categorySlug: "details",
    tags: ["选角", "时间线", "路透"],
    author: "时间轴小组",
    date: "2026-08-29",
    readTime: 6,
    views: 9840,
    hot: 78,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20hourglass%20and%20folded%20paper%20schedule%20on%20warm%20cream%20desk%2C%20terracotta%20accent%2C%20soft%20natural%20light%2C%20minimal%20editorial%20concept%20photography&width=1200&height=750&seq=hlch-timeline-04&orientation=landscape",
    coverAlt: "沙漏与折叠日程纸的静物，象征时间线还原",
    lead:
      "当一个项目进入筹备期，信息是慢慢渗出来的：先是行业内的小道消息，再是模糊路透，最后是官方口径。这 72 小时里，每一条新信息都在压缩官方的回应空间。",
    points: [
      "路透的可信度取决于拍摄角度与来源渠道，而非清晰度。",
      "打码照片的存在本身就传递了信息：它表明有人默许了流出。",
      "官宣措辞的模糊程度，往往与前期信息的充分程度成反比。",
    ],
    sections: [
      {
        heading: "第 0—24 小时：只有行业传言",
        paragraphs: [
          "这一阶段的信息形态是文字形式的「据说」，没有影像佐证，因此只在小圈子内流传。它更多起预告作用，为后续讨论设定基本框架。",
          "值得注意的是，此时官方的沉默是理性的——回应反而会把小范围话题推向大众。",
        ],
      },
      {
        heading: "第 24—56 小时：路透出现，讨论升级",
        paragraphs: [
          "当第一张现场照出现，信息从「传闻」跨入「证据」范畴。哪怕画面模糊，它也提供了一个可被反复比对的对象。",
          "接下来的连锁反应很典型：粉丝开始逐帧分析服装、车辆与取景地，讨论从「是不是」转向「为什么是」。",
        ],
      },
      {
        heading: "第 56—72 小时：官宣如何收尾",
        paragraphs: [
          "在信息已经足够多的前提下，官方声明的重点不再是「有没有」，而是「如何定性」——是合作、是洽谈，还是预留空间。",
          "措辞越谨慎，说明内部仍在协调；越直接，说明前期沟通越充分。读懂这一点，比纠结传闻真假更有价值。",
        ],
      },
    ],
  },
  {
    slug: "statement-wording-analysis",
    title: "回应声明文本分析：为什么这份公关稿反而火上浇油",
    summary:
      "一份 400 字的声明，被拆成了 12 个争点。措辞里的每一处被动语态与模糊主语，都会被读者当成线索。",
    category: "深扒解读",
    categorySlug: "deep-dive",
    tags: ["公关", "声明", "文本分析"],
    author: "临街观察",
    date: "2026-08-26",
    readTime: 10,
    views: 15880,
    hot: 93,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20close%20up%20of%20handwriting%20pen%20marks%20on%20cream%20paper%20documents%2C%20terracotta%20ink%2C%20soft%20window%20light%2C%20minimal%20stylized%20still%20life&width=1200&height=750&seq=hlch-statement-05&orientation=landscape",
    coverAlt: "纸张上的红色批注，象征公关声明的文本分析",
    lead:
      "声明是危机公关里最难写的一种文体：它要同时满足事实、情绪与法律三重约束。也正因如此，声明里的模糊之处特别多，而公众恰恰擅长从模糊里读出态度。",
    points: [
      "被动语态抽走了责任主体，读者会自动寻找替罪者。",
      "道歉对象不明确时，各方都会默认自己被忽略。",
      "补充说明发得越多，暴露的空白越多。",
    ],
    sections: [
      {
        heading: "第一个争点：主语去哪了",
        paragraphs: [
          "典型句式是「相关情况已得到处理」，问题在于谁处理的、处理了什么，全部留白。留白在文本上是安全的，在传播上却是危险的。",
          "读者面对空白不会停止解读，而会用最符合自身立场的版本去填补，于是同一句话有了互相矛盾的两种含义。",
        ],
      },
      {
        heading: "第二个争点：时间线的省略",
        paragraphs: [
          "好的声明会给出明确时间点，让公众可以自行核验；避开时间点的声明，会被认为在隐藏关键节点。",
          "这一点在法律上完全可以理解——细节越具体，越容易留下把柄。但在舆论场，风险规避常常被读成心虚。",
        ],
      },
      {
        heading: "第三个争点：情绪的分寸",
        paragraphs: [
          "道歉的分量需要与事件量级匹配。过轻显得敷衍，过重则被怀疑另有所图；这种分寸没有公式，只能靠对受众的理解。",
          "这也解释了为什么同一份声明，支持者觉得诚意十足，反对者觉得毫无悔意——情绪判断高度依赖既有立场。",
        ],
      },
      {
        heading: "结论：声明是终点还是起点",
        paragraphs: [
          "一份声明很少能真正结束争议，它更多是设定了下一阶段的讨论框架。判断它是否成功，标准不是当晚的口碑，而是三天后还有多少新问题被提起。",
        ],
      },
    ],
  },
  {
    slug: "hot-search-guidance",
    title: "热搜词条变更观察：舆论温度是如何被引导的",
    summary:
      "同一个事件，词条从「疑似」改成「回应」，讨论量没变，情绪却明显降了温。词条措辞的微调，是理解舆论场的关键切口。",
    category: "舆论观察",
    categorySlug: "opinion",
    tags: ["热搜", "词条", "舆论"],
    author: "温度计",
    date: "2026-08-23",
    readTime: 7,
    views: 11230,
    hot: 82,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20rising%20curved%20lines%20in%20terracotta%20mustard%20and%20cream%20on%20warm%20paper%20textured%20background%2C%20minimal%20data%20visualization%20concept%2C%20no%20text&width=1200&height=750&seq=hlch-trend-06&orientation=landscape",
    coverAlt: "暖色上升曲线抽象图，象征舆论热度变化",
    lead:
      "词条不是新闻标题，它更像一个给讨论定调的引子。同样的画面，用「疑似」还是「回应」开头，会决定观众带着怀疑还是带着结论进场。",
    points: [
      "词条动词的选择，直接设定了受众的默认立场。",
      "合并词条会稀释讨论密度，从而降低整体热度。",
      "降温不等于消失，只是把讨论推向更分散的角落。",
    ],
    sections: [
      {
        heading: "动词决定立场",
        paragraphs: [
          "「回应」「澄清」「曝光」「疑似」这几个词指向完全不同的事实状态。观众还没来得及看内容，就已经被动词预设了态度。",
          "所以在分析舆论时，第一步不该看评论，而该看话题本身是怎么被命名的。",
        ],
      },
      {
        heading: "合并与拆分的技术",
        paragraphs: [
          "把多个相关话题合并进一个词条，可以集中流量，也能降低单点情绪浓度；反之，拆分则会让讨论更聚焦、更激烈。",
          "这两种操作都没有善恶之分，但都能显著改变舆论的形态，值得观察者留一份记录。",
        ],
      },
      {
        heading: "普通读者能做什么",
        paragraphs: [
          "最简单的做法是给自己一点延迟：先看词条，再看评论，最后看材料。顺序变了，结论往往也会变。",
        ],
      },
    ],
  },
  {
    slug: "livestream-slip",
    title: "直播间口误事件：一句玩笑怎么就成了导火索",
    summary:
      "直播没有剪辑，也没有重来。一次语气没控制好的调侃，在切片传播里被放大了十倍，最后演变成一场持续的争议。",
    category: "细节复盘",
    categorySlug: "details",
    tags: ["直播", "切片", "传播"],
    author: "时间轴小组",
    date: "2026-08-20",
    readTime: 6,
    views: 8730,
    hot: 74,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=warm%20moody%20studio%20microphone%20and%20ring%20light%20on%20terracotta%20backdrop%2C%20soft%20diffused%20light%2C%20minimal%20editorial%20still%20life%2C%20no%20text&width=1200&height=750&seq=hlch-live-07&orientation=landscape",
    coverAlt: "暖调直播间收音麦克风静物，象征直播口误事件",
    lead:
      "直播的魅力在于即兴，风险也在于即兴。同一句话，在完整语境里可能只是玩笑，被切成十秒后却足以引爆一轮批评。",
    points: [
      "切片传播剥离了语境，语气与停顿最先被丢掉。",
      "直播事故的回应窗口极短，越晚发声越被动。",
      "多机位素材常常能还原语气，但很少被主动传播。",
    ],
    sections: [
      {
        heading: "切片如何改变语义",
        paragraphs: [
          "一条切片最常删掉的是前后文与停顿。语气靠停顿承载，语境靠前后文撑起，两者一丢，语义就会向最尖锐的方向漂移。",
          "这并不是说切片一定失真——它只是把一个瞬间抽出来，而瞬间恰恰是情绪最强的部分。",
        ],
      },
      {
        heading: "回应的黄金两小时",
        paragraphs: [
          "直播类争议的发酵速度远快于录播内容，因为它发生在实时场域，讨论与事件几乎同步。",
          "两小时内如果能给出清晰的语境说明，多数争议会停留在小范围；超过这个窗口，材料再多也很难追上已经成形的印象。",
        ],
      },
      {
        heading: "事后复盘的正确姿势",
        paragraphs: [
          "想判断真相，最有效的方式是找到多机位素材并完整听完那段对话。单独一条切片，无论播放量多高，都不足以支撑结论。",
        ],
      },
    ],
  },
  {
    slug: "endorsement-termination",
    title: "代言解约风波：商业合同里那些被忽略的条款",
    summary:
      "解约看起来是态度问题，实质是条款问题。形象条款、道德条款与赔偿区间，决定了品牌能在多快的时间里做出切割。",
    category: "幕后逻辑",
    categorySlug: "backstage",
    tags: ["代言", "合同", "法律"],
    author: "后台通道",
    date: "2026-08-17",
    readTime: 8,
    views: 10560,
    hot: 80,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=warm%20legal%20still%20life%20with%20cream%20contract%20pages%2C%20wooden%20desk%20and%20terracotta%20wax%20seal%2C%20soft%20window%20light%2C%20minimal%20editorial%20concept%20photography&width=1200&height=750&seq=hlch-contract-08&orientation=landscape",
    coverAlt: "木桌上的合同文件与印章，象征代言解约条款",
    lead:
      "品牌与艺人签约时，最被反复推敲的不是报价，而是解约条款。条款设计得越细，品牌在危机时能做的切割就越果断。",
    points: [
      "道德条款是品牌快速切割的主要依据，触发标准往往写得相当宽。",
      "赔偿区间通常与已投放的物料规模挂钩，而非固定数额。",
      "解约速度越快，越说明合同前期的风险条款越完备。",
    ],
    sections: [
      {
        heading: "道德条款到底管什么",
        paragraphs: [
          "道德条款的核心是给品牌一个「合理退出」的通道。为了避免争议，条款措辞通常覆盖范围很广，这既是品牌自保，也是艺人团队谈判的重点。",
          "所以行业内常见的情形是：合同能不能签，往往取决于双方对触发标准表述的拉锯结果。",
        ],
      },
      {
        heading: "切割为什么这么快",
        paragraphs: [
          "品牌下线物料的速度，取决于物料是否已进入渠道。线上图、线下广告牌与包装库存的处理难度完全不同，解约公告与实际下架之间常常存在时间差。",
          "这个时间差经常被误读为态度摇摆，其实更多是执行效率问题。",
        ],
      },
      {
        heading: "观察这一事件的价值",
        paragraphs: [
          "代言风波是观察商业规则如何与舆论互动的绝佳样本：它既涉及法律条款，也涉及公众情绪，两者很少完全同步。",
        ],
      },
    ],
  },
  {
    slug: "old-photos-revival",
    title: "旧照翻红现象：考古式吃瓜的传播链条",
    summary:
      "一张多年前的照片突然被翻出，配上新注解就成了热点。考古式传播为什么总能奏效？答案藏在记忆与情绪的错位里。",
    category: "舆论观察",
    categorySlug: "opinion",
    tags: ["考古", "传播", "记忆"],
    author: "温度计",
    date: "2026-08-14",
    readTime: 6,
    views: 7960,
    hot: 71,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=warm%20vintage%20photo%20album%20with%20loose%20cream%20prints%20on%20terracotta%20linen%2C%20soft%20afternoon%20light%2C%20minimal%20nostalgic%20editorial%20still%20life&width=1200&height=750&seq=hlch-archive-09&orientation=landscape",
    coverAlt: "旧相册与散落照片的暖色调静物，象征旧照考古",
    lead:
      "考古式传播的特点是低成本、高回报：不需要新素材，只要一张从未被充分解读的旧图，就能重新点燃讨论。",
    points: [
      "旧素材携带真实感，比新爆料更容易获得信任。",
      "新注解提供了重新解读的框架，是传播的启动器。",
      "这类热点的衰减极快，因为它缺乏持续的新信息供给。",
    ],
    sections: [
      {
        heading: "为什么旧照片更可信",
        paragraphs: [
          "旧素材天然带有「未经修饰」的印象，观众会默认它没有经过当下立场的加工，因此更难被质疑为造谣。",
          "但实际上，可信的是照片本身，不可信的是后来附加的解读。二者常被混为一谈。",
        ],
      },
      {
        heading: "注解才是启动器",
        paragraphs: [
          "单纯发布旧照几乎没有传播力，真正让话题动起来的是那一句新注解——它提供了观看角度，也提供了冲突点。",
          "这也意味着，判断这类热点时，最该审视的不是照片，而是注解的来源与动机。",
        ],
      },
      {
        heading: "衰减曲线为什么陡峭",
        paragraphs: [
          "考古热点缺乏后续信息，讨论很快会耗尽素材，进入重复阶段。此时热度自然回落，与「被压热搜」未必有关。",
        ],
      },
    ],
  },
  {
    slug: "fan-club-announcement",
    title: "后援会公告解读：组织化应援的运作逻辑",
    summary:
      "一份后援会公告，信息量远大于表面。措辞、署名与用词指向，都在说明组织内部如何协调一次行动。",
    category: "人物关系",
    categorySlug: "relations",
    tags: ["粉丝", "应援", "组织"],
    author: "番位观察员",
    date: "2026-08-11",
    readTime: 7,
    views: 6890,
    hot: 68,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20network%20of%20warm%20terracotta%20and%20mustard%20dots%20connected%20by%20thin%20lines%20on%20cream%20paper%2C%20minimal%20graphic%20concept%20of%20community%20organization&width=1200&height=750&seq=hlch-fandom-10&orientation=landscape",
    coverAlt: "暖色节点连线抽象图，象征粉丝组织网络",
    lead:
      "后援会公告是粉丝内部治理的公开文件。它要同时说服内部成员、回应外部质疑、并与艺人团队保持恰当距离，因此每一句都经过权衡。",
    points: [
      "署名方式透露了决策是团队共识还是个人主导。",
      "公告的用词指向，常被用来判断粉丝群体与团队的关系温度。",
      "组织化行为的稳定性，取决于内部规则是否清晰。",
    ],
    sections: [
      {
        heading: "公告在说什么",
        paragraphs: [
          "公告通常包含三部分：对事件的立场、对成员的行动要求、以及对外的态度表达。三者的比重，反映了这次沟通的主要目的。",
          "当立场部分被压缩、行动要求被放大时，说明这次沟通更偏向内部动员，而非对外解释。",
        ],
      },
      {
        heading: "署名与决策结构",
        paragraphs: [
          "以集体名义署名的公告，通常经过多轮讨论；以个人名义发出的说明，则更像临时沟通。署名方式是最直观的组织信号。",
        ],
      },
      {
        heading: "外部该如何阅读",
        paragraphs: [
          "把公告当成一份公开的组织文件来读，比把它当成情绪表达更有收获——它记录了一大群人如何协调行动，这本身就是有意思的社会观察。",
        ],
      },
    ],
  },
];

export const testimonials = [
  {
    name: "夜航船",
    role: "老读者 · 关注三年",
    text: "别家都在喊口号，这里会老老实实把时间线排出来，看完自己就能判断，这点特别难得。",
    avatar:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20illustrated%20portrait%20avatar%20of%20a%20calm%20reader%20with%20muted%20terracotta%20background%2C%20flat%20stylized%20illustration%2C%20no%20text&width=200&height=200&seq=hlch-avatar-01&orientation=squarish",
  },
  {
    name: "半糖不加冰",
    role: "内容从业者",
    text: "做宣发的人看这个号会很服气，它把很多我们内部才知道的规则讲明白了，而且不阴阳怪气。",
    avatar:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20illustrated%20portrait%20avatar%20of%20a%20young%20creative%20person%20with%20muted%20mustard%20background%2C%20flat%20stylized%20illustration%2C%20no%20text&width=200&height=200&seq=hlch-avatar-02&orientation=squarish",
  },
  {
    name: "旧报纸收藏家",
    role: "媒体观察爱好者",
    text: "喜欢它从不站队，只复盘机制。看多了就会发现，很多瓜的走向其实是可预测的。",
    avatar:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20illustrated%20portrait%20avatar%20of%20a%20thoughtful%20older%20reader%20with%20muted%20olive%20background%2C%20flat%20stylized%20illustration%2C%20no%20text&width=200&height=200&seq=hlch-avatar-03&orientation=squarish",
  },
];

export const faqs = [
  {
    q: "「黑料吃话」主要写什么内容？",
    a: "我们专注娱乐热点的深度解读，覆盖剪辑争议、商业联名、番位规则、选角传闻、声明文本与舆论变化等话题。每篇都尽量给出时间线、信源判断与多角度观点，而不是复述传闻。",
  },
  {
    q: "你们会指名道姓地曝光真实人物吗？",
    a: "不会。站内所有案例都经过脱敏化处理，以类型化的事件为样本，讨论的是传播机制与舆论逻辑，而不是对现实个体的评价。这也是我们最重要的内容底线。",
  },
  {
    q: "文章里的观点代表最终结论吗？",
    a: "不代表。我们更愿意提供分析框架，让读者自己得出结论。文中会尽量区分「已知事实」「合理推断」和「个人看法」，方便你带着批判性阅读。",
  },
  {
    q: "多久更新一次？内容会收费吗？",
    a: "通常在热点出现后一到两天内给出解读，保证信息足够再动笔。目前站内全部内容免费阅读，未来若有增值栏目会提前公告。",
  },
  {
    q: "可以投稿或提供线索吗？",
    a: "欢迎。请通过「联系我们」页面提交，附上可核验的公开链接会大大提高采纳率。对于无法核实的匿名爆料，我们一般不予采用。",
  },
  {
    q: "如何订阅最新解读？",
    a: "在首页或页脚填写邮箱即可订阅。我们只在有新解读时发送提醒，不会把邮箱用于任何其他用途，也不会分享给第三方。",
  },
];

export const siteStats = [
  { label: "深度解读", value: "1,200+", icon: "ri-article-line" },
  { label: "覆盖热点", value: "3,400+", icon: "ri-fire-line" },
  { label: "年阅读量", value: "860万", icon: "ri-eye-line" },
  { label: "更新频率", value: "每周 5 篇", icon: "ri-calendar-schedule-line" },
];